// extracted by mini-css-extract-plugin
export default {"card":"page-card_card__sDGGM"};